let fbInitPromise: Promise<void> | null = null;

export const getFbAccessToken = async () => {
  const fb = await getFb();

  if (!fb) {
    return undefined;
  }

  const response = await new Promise<facebook.StatusResponse>(resolve => {
    fb.getLoginStatus(resolve);
  });

  if (response.status === 'connected' && response.authResponse) {
    return response.authResponse.accessToken;
  }

  return undefined;
};

export const login = async () => {
  const fb = await getFb();

  if (!fb) {
    return undefined;
  }

  const response = await new Promise<facebook.StatusResponse>(resolve => {
    fb.login(resolve, { scope: 'email' });
  });

  if (response.status === 'connected' && response.authResponse) {
    return response.authResponse.accessToken;
  }

  return undefined;
};

export const logout = async () => {
  const accessToken = await getFbAccessToken();

  if (!accessToken) {
    return undefined;
  }

  const fb = await getFb();

  if (!fb) {
    return undefined;
  }

  return new Promise<object>(resolve => {
    fb.logout(resolve);
  });
};

export const getFb = async (): Promise<facebook.FacebookStatic | undefined> => {
  await fbInitPromise;
  return window.FB;
};

const mountFbScript = () => {
  const scriptId = 'facebook-jssdk';

  if (document.getElementById(scriptId)) {
    return false;
  }

  const script = document.createElement('script');
  script.id = scriptId;
  script.async = true;
  script.src = '//connect.facebook.net/en_US/sdk.js';

  const [head] = document.getElementsByTagName('head');
  head.appendChild(script);

  return true;
};

export const init = () => {
  if (process.env.FB_APP_ID) {
    fbInitPromise = new Promise<void>(resolve => {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: process.env.FB_APP_ID,
          cookie: true,
          version: 'v5.0',
        });
        resolve();
      };
    });

    if (!mountFbScript()) {
      console.warn('Facebook script already loaded');
    }
  }
};
